import React from 'react';
import { Modal, Box, Button, Typography } from '@mui/material';
import { styleModalConfirm } from '../../estilo/modal';

const ConfirmModal = ({ open, onClose, onConfirm, title, message }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styleModalConfirm}>
        <Box mb={1} display="flex" justifyContent="center">
          <Typography variant="h6" component="h2">
            {title || "¿Estás seguro?"}
          </Typography>
        </Box>
        <Typography mb={2} textAlign="center">
          {message || "Esta acción no se puede deshacer."}
        </Typography>
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="secondary"
            onClick={onClose}
            sx={{ marginRight: 2, background: 'gray' }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            sx={{ background: 'black' }}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
